import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'
import { ProjectStatus } from '@makyoapp/makyo-sdk/models/Projects'
import * as Icon from '@makyoapp/makyo-icon/icon'
import { AppCard } from '@makyoapp/makyo-ui'

import { useOrgPerm } from '@/hooks/useOrgPerm'
import { PROJECT_ROUTE } from '@/shared/constants'

interface ProjectMenuProps {
  id: string
  setStatus: (status: ProjectStatus) => void
  setDelete: () => void
  status: string
  plan: string
  href?: string
  onChangePlan: () => void
  onChangeTeams: () => void
  onTransfer: () => void
  onDuplicate: () => void
}

function MenuItem({
  id,
  className,
  icon,
  text,
  onClick,
}: {
  id: string
  className: string
  icon: ReactNode
  text: string
  onClick?: () => void
}) {
  const { t } = useTranslation()
  return (
    <AppCard.MenuItem className={className} id={`${id}-${className}`} onClick={onClick}>
      {icon}
      <span>{t(text)}</span>
    </AppCard.MenuItem>
  )
}

function ProjectMenu({
  id,
  status,
  setStatus,
  href,
  setDelete,
  onChangeTeams,
  onTransfer,
  onDuplicate,
}: ProjectMenuProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const canChangeTeams = useOrgPerm(OrgPermission.AppsChangeTeams)

  const togglePublishStatus = () =>
    setStatus(status === ProjectStatus.Published ? ProjectStatus.Unpublished : ProjectStatus.Published)

  const navigateToProject = () => navigate(`${PROJECT_ROUTE}/${id}`)

  return (
    <>
      <MenuItem
        id={id}
        className='app-publish-act'
        icon={status === ProjectStatus.Published ? <Icon.Unpublish16 /> : <Icon.Publish16 />}
        text={status === ProjectStatus.Published ? 'Unpublish' : 'Publish'}
        onClick={togglePublishStatus}
      />
      <MenuItem id={id} className='app-edit-act' icon={<Icon.Edit16 />} text='Edit' onClick={navigateToProject} />
      <MenuItem
        id={id}
        className='app-change-domain-act'
        icon={<Icon.EditDomain16 />}
        text='Change Domain'
        onClick={navigateToProject}
      />
      {status === ProjectStatus.Published && href && (
        <MenuItem id={id} className='app-visit-act' icon={<Icon.OpenNew16 />} text='Visit' />
      )}
      {status === ProjectStatus.Published && (
        <MenuItem id={id} className='app-share-act' icon={<Icon.Share16 />} text='Share' />
      )}
      {canChangeTeams && (
        <MenuItem
          id={id}
          className='app-change-teams-act'
          icon={<Icon.Team16 />}
          text='Change Teams'
          onClick={onChangeTeams}
        />
      )}
      <MenuItem
        id={id}
        className='app-duplicate-act'
        icon={<Icon.Copy16 />}
        text='Duplicate App'
        onClick={onDuplicate}
      />
      {/* <MenuItem
        id={id}
        className='app-transfer-act'
        icon={<Icon.PaperPlane24 className='w-5 h-4' />}
        text='Transfer'
        onClick={onTransfer}
      /> */}
      <MenuItem id={id} className='app-remove-act red' icon={<Icon.Trash16 />} text='Remove' onClick={setDelete} />
    </>
  )
}

export default ProjectMenu
